import { render, staticRenderFns } from "./customer-ledger.vue?vue&type=template&id=564ef12b"
import script from "./customer-ledger.vue?vue&type=script&lang=js"
export * from "./customer-ledger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports